module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// /root/anvel/~/readable-stream/transform.js
// module id = ../../../../readable-stream/transform.js
// module chunks = 4